export const actions = {
  SELECT_COMMITMENT: 'SELECT_COMMITMENT',
  UNSELECT_COMMITMENT: 'UNSELECT_COMMITMENT',
  SET_COOLFOODER_INFOS: 'SET_COOLFOODER_INFOS',
  SET_HAPPENING: 'SET_HAPPENING',
  SET_COMMIT: 'SET_COMMIT',
  SHOW_MODAL: 'SHOW_MODAL',
  SET_HINTS: 'SET_HINTS',
  SET_STEPS: 'SET_STEPS',
  SET_LANG: 'SET_LANG',
  SET_CURRENT_SLIDE: 'SET_CURRENT_SLIDE',
  SET_NUMBER_OF_BENEFICIARIES: 'SET_NUMBER_OF_BENEFICIARIES',
  PREV_SLIDE: 'PREV_SLIDE',
  NEXT_SLIDE: 'NEXT_SLIDE',
  SHOW_HELP: 'SHOW_HELP',
  SHOW_SCREEN: 'SHOW_SCREEN',
  COMMITS_VALIDATED: 'COMMITS_VALIDATED',
};

const setCommit = (state, commit) => {
  // If commit with same id, remove it
  const newState = state.commits.filter(c => c.id !== commit.id);
  // add commit to list
  newState.push(commit);
  return newState;
};

function reducer(state, action) {
  switch (action.type) {
  case actions.SET_HAPPENING:
    return { ...state, happening: action.happening };
  case actions.SELECT_COMMITMENT:
    return {
      ...state,
      selectedCommitments: [...state.selectedCommitments, action.id]
    };
  case actions.UNSELECT_COMMITMENT:
    return {
      ...state,
      ...{
        // Remove commitment to selected commitments
        selectedCommitments: state.selectedCommitments.filter(
          id => id !== action.id
        ),
        // Remove commit done by user for this commitment
        commits: state.commits.filter(c => {
          return c.id !== action.id;
        })
      }
    };
  case actions.SET_COMMIT:
    return { ...state, commits: setCommit(state, action.commit) };
  case actions.SET_COOLFOODER_INFOS:
    return { ...state, coolfooder: { ...state.coolfooder, ...action.infos } };
  case actions.SHOW_MODAL:
    return { ...state, commitmentModal: action.id };
  case actions.SET_HINTS:
    return { ...state, hints: action.hints };
  case actions.SET_STEPS:
    return { ...state, steps: action.steps };
  case actions.SET_CURRENT_SLIDE:
    return { ...state, currentSlide: action.currentSlide };
  case actions.PREV_SLIDE:
    return {
      ...state,
      currentSlide: state.currentSlide > 0 ? state.currentSlide - 1 : 0
    };
  case actions.NEXT_SLIDE:
    return { ...state, currentSlide: state.currentSlide + 1 };
  case actions.SHOW_HELP:
    return { ...state, helpContent: action.content };
  case actions.SHOW_SCREEN:
    return { ...state, screenContent: action.content };
  case actions.COMMITS_VALIDATED:
    return { ...state, commitsValidated: action.status };
  case actions.SET_NUMBER_OF_BENEFICIARIES:
    return { ...state, numberOfBeneficiaries: action.data};
  case actions.SET_LANG:
    return { ...state, language: action.lang};
  default:
    return state;
  }
}
export default reducer;
